export default "__VITE_ASSET__BdGSpZ$C__"